import React from "react";
import { useTranslation } from "react-i18next";

import { FolderIcon } from "@common/folderIcon";
import { CloseIcon } from "@common/assets/closeIcon";
import { ProjectModelsIcon } from "@common/assets/projectModelsIcon";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectTypeChoice({ createProject, useModel, close }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.projectTypeChoice}>
      <div className={styles.header}>
        <h1 className={styles.title}>
          {t("projectCreation.projectTypeChoice.title")}
        </h1>
        <div onClick={close} className={styles.removeIconBox}>
          <CloseIcon className={styles.removeIcon} />
        </div>
      </div>
      <div className={styles.main}>
        <p className={styles.subTitle}>
          {t("projectCreation.projectTypeChoice.subTitle")}
        </p>
        <div className={styles.choices}>
          <div className={styles.choice} onClick={createProject}>
            <div className={styles.iconBox}>
              <FolderIcon className={styles.icon} />
            </div>
            <div className={styles.column}>
              <p className={styles.name}>
                {t("projectCreation.projectTypeChoice.project.title")}
              </p>
              <p className={styles.description}>
                {t("projectCreation.projectTypeChoice.project.description")}
              </p>
            </div>
          </div>
          <div className={styles.choice} onClick={useModel}>
            <div className={styles.iconBox}>
              <ProjectModelsIcon className={styles.icon} />
            </div>
            <div className={styles.column}>
              <p className={styles.name}>
                {t("projectCreation.projectTypeChoice.projectModel.title")}
              </p>
              <p className={styles.description}>
                {t(
                  "projectCreation.projectTypeChoice.projectModel.description",
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { ProjectTypeChoice };
